export default function Marquee({ content, language }) {
  const items = language === "en" ? content.marquee_en : content.marquee_es;
  const repeated = [...items, ...items];
  return (
    <div className="marquee-window" data-testid="editorial-marquee" aria-label="Services and service areas">
      <div className="marquee-track">
        {repeated.map((item, index) => <span className="marquee-item" key={`${item}-${index}`}>{item}<b>✦</b></span>)}
      </div>
    </div>
  );
}
